import React, { useEffect, useState } from 'react';
import requests from '../../../Services/HttpServices';
import './LampadePopup.scss';
import './LampadaRenewalPopup.scss';

const dateLabel = value => value ? value.slice(0, 10).split('-').reverse().join('/') : 'Non disponibile';

function requestKey() {
  if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
}

export default function LampadaRenewalPopup({ deceasedID, deceasedName, lamp, close, completed }) {
  const [quote, setQuote] = useState(null);
  const [key, setKey] = useState(null);
  const [busy, setBusy] = useState(true);
  const [alreadyRenewed, setAlreadyRenewed] = useState(false);
  const [error, setError] = useState('');
  const currentExpiry = lamp.dataTermineAccensione ? lamp.dataTermineAccensione.slice(0, 10) : '';

  const getQuote = async () => {
    setBusy(true);
    setError('');
    setQuote(null);
    setKey(null);
    setAlreadyRenewed(false);
    try {
      const result = await requests('post', 'lampadaRenewalQuote', { idDefunto: deceasedID });
      if (result?.response !== 'success') {
        setAlreadyRenewed(result?.errorCode === 'LAMP_ALREADY_RENEWED');
        throw new Error(result?.message || 'Impossibile calcolare il preventivo');
      }
      setQuote(result.data);
      setKey(requestKey());
    } catch (e) {
      setError(e.message || 'Errore di connessione');
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => { getQuote(); }, [deceasedID]); // eslint-disable-line react-hooks/exhaustive-deps

  const confirm = async () => {
    setBusy(true);
    setError('');
    try {
      const result = await requests('post', 'lampadaRenewalConfirm', {
        idDefunto: deceasedID,
        newExpiry: quote.newExpiry,
        requestKey: key,
        expectedExpiry: quote.currentExpiry || '',
        expectedAnnualPrice: quote.annualPrice,
        expectedCredits: quote.credits,
        expectedSerial: quote.serialeLampada,
        expectedBaseDate: quote.paidUntil
      });
      if (result?.response !== 'success') {
        if (['QUOTE_CHANGED', 'LAMP_ALREADY_RENEWED'].includes(result?.errorCode)) {
          setQuote(null); setKey(null);
          setAlreadyRenewed(result.errorCode === 'LAMP_ALREADY_RENEWED');
        }
        throw new Error(result?.message || 'Rinnovo non completato');
      }
      completed(result.data);
    } catch (e) {
      setError(e.message || 'Errore di connessione. Puoi riprovare con la stessa conferma.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="lampade-main-container lampada-renewal-overlay" onClick={() => { if (!busy) close(); }}>
      <section className="lampade-card lampada-renewal-card" onClick={e => e.stopPropagation()} aria-label="Rinnova Lampada">
        <label className="ttitle">Rinnova Lampada</label>
        <label className="subbtitle"><strong>{deceasedName} (Seriale Lampada: {lamp.serialeLampada})</strong></label>
        <dl className="renewal-details">
          <div><dt>Pagata fino al</dt><dd>{dateLabel(lamp.pagatoFinoA)}</dd></div>
          <div><dt>Attuale spegnimento della lampada</dt><dd>{dateLabel(currentExpiry)}</dd></div>
        </dl>
        <p><em>Questo rinnovo serve per pagare un anno, gli eventuali arretrati si saldano un anno alla volta, fino all’anno corrente.</em></p>
        {busy && <p role="status">Operazione in corso…</p>}
        {quote && (
          <div className="lampada-renewal-summary">
            <h3>Pagamento Anno {quote.paymentYear}</h3>
            <dl className="renewal-details">
              <div><dt>La lampada sarà pagata fino al</dt><dd>{dateLabel(quote.newPaidUntil)}</dd></div>
              <div><dt>Nuova data di spegnimento</dt><dd>{dateLabel(quote.newExpiry)}</dd></div>
              <div><dt>Saldo disponibile</dt><dd>{Number(quote.balance).toFixed(2)} crediti</dd></div>
              <div className="renewal-total"><dt>Totale da pagare</dt><dd>{Number(quote.credits).toFixed(2)} crediti</dd></div>
            </dl>
            {!quote.canPay && <p className="lampada-renewal-error">Saldo insufficiente. Ricarica i creditiprima di continuare.</p>}
          </div>
        )}
        {error && <p role="alert" className="lampada-renewal-error">{error}</p>}
        <div className="renewal-actions">
          <button className="lampada-renewal-close" disabled={busy} onClick={close}>Indietro</button>
          {!busy && !quote && !alreadyRenewed && <button onClick={getQuote}>Riprova</button>}
          {quote && <button disabled={busy || !quote.canPay} onClick={confirm}>Conferma e Paga</button>}
        </div>
      </section>
    </div>
  );
}
